import { Calendar, CalendarProps, CalendarChangeParams } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import { addLocale } from 'primereact/api'
import i18n from 'i18next'
import { classNames } from 'primereact/utils'
import './DatePickerIcon.scss'

interface IDatePickerIconProps extends CalendarProps {
  idName: string
  defaultDate: Date | Date[] | undefined
  onSelectedDateChange: (e: CalendarChangeParams) => void | undefined
  label: string | undefined
}

const handleOnFocus = () => {
  let datepickerPanel = document.getElementsByClassName('p-datepicker p-component')
  for (let i = 0; i < datepickerPanel.length; i++) {
    datepickerPanel[i].className += ' topHeight'
  }
}

const DatePickerIcon = ({
  disabledDays = [0, 6],
  appendTo = 'self',
  onFocus = handleOnFocus,
  ...props
}: IDatePickerIconProps) => {
  addLocale('tr', {
    firstDayOfWeek: 1,
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Pzr', 'Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts'],
    dayNamesMin: ['Pz', 'Pt', 'S', 'Ç', 'P', 'C', 'Ct'],
    monthNames: [
      'Ocak',
      'Şubat',
      'Mart',
      'Nisan',
      'Mayıs',
      'Haziran',
      'Temmuz',
      'Ağustos',
      'Eylül',
      'Ekim',
      'Kasım',
      'Aralık',
    ],
    monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    today: 'Bugün',
    clear: 'Temizle',
    apply: 'Kaydet',
  })

  const monthNavigatorTemplate = (e: any) => {
    return (
      <Dropdown
        value={e.value}
        options={e.options}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        style={{ lineHeight: 1 }}
      />
    )
  }

  const yearNavigatorTemplate = (e: any) => {
    return (
      <Dropdown
        value={e.value}
        options={e.options}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        className="p-ml-2"
        style={{ lineHeight: 1 }}
      />
    )
  }

  return (
    <div className="datePickerIcon">
      <label>{props.label}</label>
      <Calendar
        id={props.idName}
        className={classNames('w-100', props.className)}
        value={props.defaultDate}
        disabledDays={disabledDays}
        onChange={props.onSelectedDateChange}
        showIcon
        appendTo={appendTo}
        readOnlyInput={true}
        monthNavigatorTemplate={monthNavigatorTemplate}
        yearNavigatorTemplate={yearNavigatorTemplate}
        locale={i18n.language}
        dateFormat={'dd.mm.yy'}
        onFocus={(e) => onFocus(e)}
        {...props}
      />
    </div>
  )
}
export default DatePickerIcon
